<div class="d-flex">
  <app-components-navbar></app-components-navbar> 
  <div class="capsule">
    <app-navtabs [type]="'attestations'"></app-navtabs>
  </div>
</div>
